// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"SunburstChart-chartWrapper-2w11nO"};